export default {"src":"/_next/static/media/more_bold.177c0b45.svg","height":24,"width":24};